const StatesNames = {
        AN  :{ name : 'Andaman and Nicobar Islands', color: '#e67e22'},
        AP  : { name :'Andhra Pradesh', color: '#27ae60'},
        AS  : { name :'Assam', color: '#8e44ad'},
        BR  : { name :'Bihar', color: '#e74c3c'},
        CH  : { name :'Chandigarh', color: '#2980b9'},
        CT  : { name :'Chhattisgarh', color: '#e74c3c'},
        DL  : { name :'Delhi', color: '#fd9644'},
        DN  : { name :'Dadra and Nagar Haveli and Daman and Diu', color: '#f7b731'},
        GA  : { name :'Goa', color: '#eb3b5a'},
        GJ   : { name :'Gujrat', color: '#f39c12'},
        HP   : { name :'Himachal Pradesh', color: '#3867d6'},
        HR   : { name :'Haryana', color: '#8e44ad'},
        JH   : { name :'Jharkhand', color: '#e74c3c'},
        JK   : { name :'Jammu and Kashmir', color: '#8854d0'},
        KA   : { name :'Karnataka', color: '#eb3b5a'},
        KL   : { name :'Kerala', color: '#2980b9'},
        LA   : { name :'Ladakh', color: '#0fb9b1'},
        LD   : { name :'Lakshadweep', color: '#eb3b5a'},
        MH   : { name :'Maharastra', color: '#fd9644'},
        MP   : { name :'Madhya Pradesh', color: '#8854d0'},
        MZ   : { name :'Mizoram', color: '#8e44ad'},
        NL   : { name :'Nagaland', color: '#0fb9b1'},
        OR   : { name :'Orissa', color: '#eb3b5a'},
        PB   : { name :'Punjab', color: '#e74c3c'},
        PY   : { name :'Pondicherry', color: '#3867d6'},
        RJ   : { name :'Rajasthan', color: '#fd9644'},
        SK   : { name :'Sikkim', color: '#8e44ad'},
        TG   : { name :'Telangana', color: '#f39c12'},
        TN   : { name :'Tamil Nadu', color: '#0fb9b1'},
        TR   : { name :'Tripura', color: '#e74c3c'},
        UP   : { name :'Uttar Pradesh', color: '#27ae60'},
        UT   : { name :'Uttarakhand', color: '#2980b9'},
        WB   : { name :'West Bengal', color: '#e67e22'}
    
}
export default StatesNames;